import { get } from 'lodash'
import { ACTIVITY_CATEGORIES } from 'constants/enums'

export default function(fields, { organizationId }){
  const transportationModes = get(fields, 'transportationModes') || []

  const transportationModeList = transportationModes && transportationModes.map(item => {
    return {
      ajEvent: { id : get(fields, 'id') },
      transportationMode: {
        id: get(item, 'id')
      }
    }
  })

  let model = {
    organization: {
      id: organizationId || get(fields, 'organization.id')
    },
    ajEventCategory: {
      value: get(fields, 'ajEventCategory.value')
    },
    modeOfTransportType: {
      value: get(fields, 'modeOfTransportType.value')
    },
    activityCategory: {
      id: get(fields, 'activityCategory.id')
    },
    note: get(fields, 'note'),
    title: get(fields, 'title'),
    awardLevel: {
      value: get(fields, 'awardLevel.value')
    },
    location: get(fields, 'location'),
    country: {
      id: get(fields, 'country.id')
    },
    otherLocationInformation: get(fields, 'otherLocationInformation'),
    transportationModes: transportationModeList
  }

  if (get(fields, 'activityCategory.id') === ACTIVITY_CATEGORIES.other.id) {
    model = {
      ...model,
      activityCategory: {
        ...model.activityCategory,
        activitySection: get(fields, 'activitySection'),
        userDefined: true,
        name: fields.otherName,
        id: undefined,
        parent: {
          id: get(fields, 'activityCategory.parent.id')
        }
      }
    }
  }

  return model
}
